import { Component, computed, inject, signal } from '@angular/core';
import { NotificationsService } from '../notifications.service';
import { MatMenuModule } from '@angular/material/menu';
import { MomentModule } from 'ngx-moment';
import { NotifyBellComponent } from '@exl-ng/mulo-common';
import { BriefComponent } from '@exl-ng/mulo-views';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { UrlUtils } from '../../shared/utils/url.utils';
import { SlicePipe } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { OverlayModule } from '@angular/cdk/overlay';
import { RequestsService } from '../../profile/requests/requests.service';
import {
    EntityRequestDTO,
    ResearchEntityRequestStatus,
} from '../../shared/interfaces/request';
import moment from 'moment';
import { MatButtonModule } from '@angular/material/button';
import { ResourceTypeUtils } from '../../shared/utils/resource-type.utils';
import { INSTITUTION_CODE } from '../../app.component';

@Component({
    selector: 'esp-notifications-menu',
    imports: [
        MatMenuModule,
        MatButtonModule,
        MomentModule,
        NotifyBellComponent,
        RouterLink,
        TranslatePipe,
        BriefComponent,
        SlicePipe,
        MatTabsModule,
        OverlayModule,
    ],
    templateUrl: './notifications-menu.component.html',
    styleUrl: './notifications-menu.component.scss',
})
export class NotificationsMenuComponent {
    notifySvc = inject(NotificationsService);
    requestsSvc = inject(RequestsService);
    protected institution = inject(INSTITUTION_CODE);
    itemLimit = 5;

    readonly menuOpen = signal(false);

    claimOutputs = this.notifySvc.streamMap().get('outputClaim');
    requests = computed(() => {
        const notifyStream = this.notifySvc.streamMap().get('requests');
        return notifyStream()?.map((request: EntityRequestDTO) => {
            const asset = this.requestsSvc.assets()?.[request.entityId];
            return {
                id: request.requestId,
                assetType: asset?.resourceType,
                assetTitle: asset?.title,
                requester: request.requesterName,
                date: moment(request.createdDate).toDate(),
            };
        });
    });

    toggleMenu() {
        this.menuOpen.update((open) => !open);
    }

    closeMenu() {
        this.menuOpen.set(false);
    }
}
